

















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditBasePartenaire from '@/components/partenaire/edit/EditBasePartenaire.vue';
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloPartenaire, getDefaultAloPartenaire } from '@/models/alo/AloPartenaire';
import * as rules from '@/utils/validationRules'

@Component({
  name: 'EditFtp',
  components:{EditBasePartenaire}
})
export default class EditFtp extends Vue {
  
  private partenaire = getDefaultAloPartenaire()
  
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloPartenaire) {    
    this.partenaire = (this.$refs.baseEdit as EditBasePartenaire).edit(item)
  }  
  
}
